__webpack_require__.p = "/ncviewtakoradi/";